import { extractArrayFromQuery } from '../../../utils/query';
import moment from 'moment-timezone';

export default {
  param: extractArrayFromQuery,
  having: function (values, timestamp) {
    if (!timestamp) {
      throw new Error('Required param (timestamp) is missing');
    }

    if (values.length > 0) {
      return {
        $or: values.map(function(value) {
          return {
            createdAt: {
              $gte: moment(timestamp).subtract(Number(value), 'weeks').toISOString()
            }
          }
        })
      }
    }
  }
}
